import {Component} from '@angular/core';
import {AbstractIcon} from '../abstract-icon';

@Component({
    selector: 'vui-invalid-icon',
    templateUrl: './invalid-icon.component.html',
    styleUrls: ['./invalid-icon.component.scss']
})
export class InvalidIconComponent extends AbstractIcon {
    constructor() {
        super();
        this.height = 24;
        this.width = 24;
    }
}
